module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal saved-messages-modal animated fadeIn"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Create New Saved Message")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.newMessage()
      }
    }
  }, [_c('span', [_vm._v("+")]), _vm._v(" New Saved Message\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.messages,
      "placeholder": "Select Message",
      "track-by": "id",
      "label": "subject",
      "showLabels": false
    },
    model: {
      value: (_vm.selectedMessage),
      callback: function($$v) {
        _vm.selectedMessage = $$v
      },
      expression: "selectedMessage"
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.options.showForm),
      expression: "options.showForm"
    }],
    staticClass: "form-wrapper"
  }, [_c('div', {
    staticClass: "float-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.subject),
      expression: "form.subject"
    }],
    attrs: {
      "type": "text",
      "name": "subject",
      "id": "subject",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "subject", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "subject"
    }
  }, [_vm._v("Subject")])]), _vm._v(" "), _c('div', {
    staticClass: "float-label"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.body),
      expression: "form.body"
    }],
    attrs: {
      "name": "message",
      "id": "message",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "body", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")])])])])], 1), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut"
    }
  }, [(_vm.options.showForm) ? _c('div', [(_vm.form.id) ? _c('button', {
    staticClass: "button is-primary is-large",
    on: {
      "click": function($event) {
        _vm.updateMessage()
      }
    }
  }, [_vm._v("Update Message")]) : _vm._e(), _vm._v(" "), (_vm.form.id) ? _c('button', {
    staticClass: "button is-primary is-large",
    on: {
      "click": function($event) {
        _vm.deleteMessage()
      }
    }
  }, [_vm._v("Delete Message")]) : _vm._e(), _vm._v(" "), (!_vm.form.id) ? _c('button', {
    staticClass: "button is-primary is-large",
    on: {
      "click": function($event) {
        _vm.createMessage()
      }
    }
  }, [_vm._v("Create Message")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-outlined is-large",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd3bfb4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/saved-messages-modal.vue
// module id = 513
// module chunks = 0